<template>
  <div :id="this.id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="LineComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="50"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">
			<rotate :target="this.$refs.draggableResizable" :config="this.internal_config" />
			<sync-drag :target="this" />
      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-LineComponent'></options-element-bar>

      <div class="container-line-hor">
        <div class="arrow arrow-left" v-if="internal_config.arrowLeft.active" :style="styleArrowLeft()"></div>
        <div :config-properties="JSON.stringify(internal_config)" class=" sitebuilder-element"
             v-bind:style="{'border-radius': radius, 'border-bottom' : border, 'box-shadow': boxShadow, marginLeft: marginleft, marginRight : marginright}"></div>
        <div class="arrow arrow-right" v-if="internal_config.arrowRight.active" :style="styleArrowRight()"></div>
      </div>


      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>

<script>

	import Model from './Model';
	import Resources from './Resources.vue';
  import OptionsElementBar from "../OptionsElementBar";
  import MixinComponents from "../../../../js/mixins/MixinComponents";

	export default {
    name: 'LineComponent',
    props: ['config', 'src', 'id', 'preview'],
    mixins: [MixinComponents],
    components: {
      OptionsElementBar,
      Resources,
    },
    computed: {
      marginleft() {
        if (this.internal_config.arrowLeft.active) {
          return this.internal_config.arrowLeft.size + 'px';
        }
        return '';
      },
      marginright() {
        if (this.internal_config.arrowRight.active) {
          return this.internal_config.arrowRight.size + 'px';
        }
        return '';
      }
    },
    data() {
      return Model.data();
    },
    watch: {
      'internal_config': {
        deep: true,
        handler(value) {
          this.$eventHub.setValueElementConfig(this.id, value);
          this.$eventPointer.log(this.id, value);
        }
      },
    },

    methods: {

      animation() {
        return true;
      },

      onResize: function (x, y, width, height) {
        this.internal_config.width = width + 'px';
        this.internal_config.height = height + 'px';

        this.$refs.resourcesData.setValuesData(this);
      },

      showResources() {
        return this.$refs.resourcesData.getValuesData();
      },

      build(config) {
        this.internal_config = config;
      },

      style() {
        var style = `width: ${this.internal_config.width};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     left:  ${this.internal_config.left};
                     top: ${this.internal_config.top}`;
        return style;
      },
      styleArrowLeft() {

        var style = `border-top-width: ${this.internal_config.arrowLeft.size}px;
                     border-bottom-width: ${this.internal_config.arrowLeft.size}px;
                     border-right-width: ${this.internal_config.arrowLeft.size}px;
                     top: calc(50% - ${this.internal_config.arrowLeft.size}px);
                     border-right-color: ${this.internal_config.arrowLeft.color};`;
        return style;
      },
      styleArrowRight() {

        var style = `border-top-width: ${this.internal_config.arrowRight.size}px;
                     border-bottom-width: ${this.internal_config.arrowRight.size}px;
                     border-left-width: ${this.internal_config.arrowRight.size}px;
                     top: calc(50% - ${this.internal_config.arrowRight.size}px);
                     border-left-color: ${this.internal_config.arrowRight.color};`;
        return style;
      },
      styleResize() {
        return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
      },
    },
    created() {
      this.build(this.$props.config);
    },
    mounted() {
      this.internal_config = window.mergeRecursive(this.props, this.$props.config);
      if (this.$props.preview) {
        this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
      }

      let objIds = [];
      $('[id]').each(function () {
        var ids = $('[id="' + this.id + '"]');
        if (ids.length > 1 && ids[0] == this && parseInt(this.id))
          objIds.push(this.id);
      });
      if (objIds.includes(this.id)) {
        this.id = Date.now() + parseInt(Math.random() * 10000);
      }

      this.$root.$on('setConfigElement', (id, obj) => {
        if (this.id == id) {
          this.config = obj;
          this.internal_config = obj;
        }
      });

      this.$refs.resourcesData.setValuesData(this);
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  [data-device="desktop"] [element="LineComponent"] .vdr {
    padding-top: 15px !important;
    padding-bottom: 15px !important;
  }

  .container-line-hor {
    position: relative;
  }

  .arrow {
    position: absolute;
    width: 0;
    height: 0;
  }

  .arrow-right {
    border-top-color: transparent;
    border-top-style: solid;
    border-bottom-color: transparent;
    border-bottom-style: solid;

    border-left-style: solid;
    right: 0;
  }

  .arrow-left {
    border-top-color: transparent;
    border-top-style: solid;
    border-bottom-color: transparent;
    border-bottom-style: solid;

    border-right-style: solid;
  }

</style>
<style scoped>

  .resizable.vdr {
    width: 100% !important;
    height: auto !important;
    left: 0 !important;
    top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Line/Line.vue